import { Navigate, Outlet } from 'react-router';

import { useUser } from '@/components/auth-provider';

export function PublicRoute() {
  const { user } = useUser();

  if (user) {
    return <Navigate to="/promotions" replace />;
  }

  return <Outlet />;
}
